var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14210",
    "data-name": "Rectangle 14210",
    width: 50,
    height: 30,
    transform: "translate(-1897 -5956)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5275",
    "data-name": "Mask Group 5275",
    transform: "translate(1897 5956)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dizlogoOrigin1",
    transform: "translate(-1897 -5954.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M284.047,272v-4.68a8.278,8.278,0,1,0,.007-16.556l-3.888.061-.072-4.679,3.923-.061A12.959,12.959,0,1,1,284.046,272Z",
    transform: "translate(-276.839 -246.074)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2621",
    "data-name": "Rectangle 2621",
    width: 4.534,
    height: 25.879,
    transform: "translate(22.975 0.051)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2622",
    "data-name": "Rectangle 2622",
    width: 4.683,
    height: 25.893,
    transform: "translate(0 0.037)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(31.977 0.158)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M327.078,252.77a10.669,10.669,0,0,0-12.341-.05l-2.819-3.551a15.175,15.175,0,0,1,18.02.084Z",
    transform: "translate(-311.917 -246.247)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M320.879,274.015a14.4,14.4,0,0,1-8.958-2.924l2.819-3.551a10.668,10.668,0,0,0,12.341-.05l2.86,3.517A14.342,14.342,0,0,1,320.879,274.015Z",
    transform: "translate(-311.919 -248.243)",
    fill: "#0c78bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(34.418 7.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M328.958,256a4.94,4.94,0,0,0-.558-1.634,7.449,7.449,0,0,1-.63,1.919",
    transform: "translate(-315.838 -254.362)",
    fill: "#85bc4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M326.595,260.943a4.935,4.935,0,0,0,2.017-4.681l-1.25.3a8.031,8.031,0,0,1-3.486,3.02",
    transform: "translate(-315.475 -254.539)",
    fill: "#aece71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M321.476,263.673a17.374,17.374,0,0,0,4.6-2.3l-2.708-1.366c-.384.207-.8.415-1.266.628A24.06,24.06,0,0,0,319.559,262",
    transform: "translate(-315.073 -254.89)",
    fill: "#7bb94f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M315.148,266.441c.906-.848,3.316-1.53,5.788-2.487l-1.888-1.661c-3.525,2-3.9,4.149-3.9,4.149",
    transform: "translate(-314.662 -255.101)",
    fill: "#50a734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M326.028,257.8a6.135,6.135,0,0,0,2.088-3.441,11.845,11.845,0,0,1-2.245,1.1",
    transform: "translate(-315.661 -254.362)",
    fill: "#aece71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M316.477,259.942c-3.057,2.456-1.436,6.237-1.436,6.237a5.106,5.106,0,0,1,1.98-3.1",
    transform: "translate(-314.612 -254.882)",
    fill: "#50a734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M321.45,260.306c.263-.132.379-.207.67-.34a16.477,16.477,0,0,0,3.365-1.975l-.154-2.36c-1.334.595-2.7,1.044-4.007,1.643",
    transform: "translate(-315.237 -254.479)",
    fill: "#85bc4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M317.359,262.746a18.026,18.026,0,0,1,3.543-2.206l-.143-3.027c-.664.275-1.534.712-1.943.91a8.768,8.768,0,0,0-2,1.209",
    transform: "translate(-314.815 -254.656)",
    fill: "#5cae3e"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiz);
export default __webpack_public_path__ + "static/media/diz.2eefedaa78bb52d3a6bc9a136d0719c8.svg";
export { ForwardRef as ReactComponent };